<template>
  <div class="layout-container">
    <headerComponent @on-scroll="onScroll" />
    <div class="container" :class="{ 'aniamtion-top': scrollTop === 0 }">
      <div class="content">
        <transition name="fade" mode="out-in">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import headerComponent from './header.vue'

export default {
  components: { headerComponent },
  props: {},
  data () {
    return {
      scrollTop: 0
    }
  },
  mounted () {

  },
  methods: {
    onScroll (scrollTop) {
      this.scrollTop = scrollTop
    }
  }
}
</script>

<style lang="less" scoped>
.layout-container {
  // .aniamtion-top {
  //   margin-top: 107px !important;
  // }
  .container {
    transition: all 1s;
    margin-top: 60px;
    background-color: #fff;
  }
  @media screen and (max-width: 1024px) {
    .container {
      margin-top: 44px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/index.vue